import { useT } from '../i18n';
import { useTheme } from '../theme/store';

/*
    One click between dark and light, in the chrome rather than three clicks into
    settings. Switching from `system` picks the opposite of whatever the system
    currently resolves to, so the button always does the visible thing.
*/
export default function ThemeToggle() {
    const mode = useTheme((s) => s.mode);
    const resolved = useTheme((s) => s.resolved);
    const setMode = useTheme((s) => s.setMode);
    const { t } = useT();

    const next = resolved === 'dark' ? 'light' : 'dark';
    const title = t(next === 'light' ? 'theme.toggleToLight' : 'theme.toggleToDark');

    return (
        <button
            data-hit
            onClick={() => setMode(next)}
            title={mode === 'system' ? `${title} (${t('settings.system')})` : title}
            aria-label={title}
            style={{
                width: 26,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: '0 0 auto',
                background: 'var(--chip-bg)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--r-btn)',
                color: 'var(--text-mute)',
            }}
        >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                {resolved === 'dark' ? (
                    <>
                        <circle cx="12" cy="12" r="4" />
                        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
                    </>
                ) : (
                    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />
                )}
            </svg>
        </button>
    );
}
